import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDTitleText, FDBodyText, FDDialogTitle } from '@facet-wealth/design';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('welcomeTitle', {
    _component: () => FDTitleText,
  }, overrideReadOnly)
  .nameOverride('welcomeDescription', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDTitleText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .done();

const YourRoadmapIsReadyTemplate = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

export default YourRoadmapIsReadyTemplate;
